import icon_10 from '@/static/running_plan/icon_10.png'
	import icon_11 from '@/static/running_plan/icon_11.png'
	import icon_12 from '@/static/running_plan/icon_12.png'
	import icon_13 from '@/static/running_plan/icon_13.png'
	import icon_14 from '@/static/running_plan/icon_14.png'
	import icon_15 from '@/static/running_plan/icon_15.png'
	import icon_16 from '@/static/running_plan/icon_16.png'

export default {
	10: {
		label: '加班车',
		icon: icon_10
	},
	11: {
		label: '机场专线',
		icon: icon_11
	},
	12: {
		label: '全程高速',
		icon: icon_12
	},
	13: {
		label: '旅游专线',
		icon: icon_13
	},
	14: {
		label: '高铁站',
		icon: icon_14
	},
	15: {
		label: '火车站',
		icon: icon_15
	},
	16: {
		label: '限时优惠',
		icon: icon_16
	}
}